/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Image_SurveysInputs */



/**
* | output |
* | --- |
* | "Draught marks on a ship's bow" |
*
* @param {Services_Image_SurveysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_image_surveys = /** @type {((inputs?: Services_Image_SurveysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Image_SurveysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("船艏的水尺标记")
	return /** @type {LocalizedString} */ ("Draught marks on a ship's bow")
});